const SingleTicketIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    fill="none"
    viewBox="0 0 21 21"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12.366 6.033-5.303 5.303M12.66 9.273l-2.357 2.357M16.49 6.621l-2.946-2.946a1.667 1.667 0 0 0-2.357 0l-6.482 6.482c-.65.65-.65 1.706 0 2.357L7.65 15.46c.651.651 1.706.651 2.357 0l6.482-6.482c.65-.65.65-1.706 0-2.357"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.583 8.916a2.5 2.5 0 0 1 0-2.994.42.42 0 0 0-.039-.544L14.788.622a.416.416 0 0 0-.544-.04 2.5 2.5 0 0 1-2.994 0 .42.42 0 0 0-.544.04L.5 10.827a.833.833 0 0 1 0 1.18l7.66 7.66a.83.83 0 0 1 1.18 0L19.543 9.46a.42.42 0 0 0 .04-.544"
    ></path>
  </svg>
);

export default SingleTicketIcon;
